import { useRef, useEffect, useState, FC } from 'react';

import { getPoster } from '../../utils/player';

import * as Styled from './preview-mode.styles';

type Props = {
  posterImage?: string;
  thumbnails: PlayerThumbnail[];
  onClick: () => void;
  buttonSize?: number;
};
export const PreviewMode: FC<Props> = ({
  posterImage,
  thumbnails,
  onClick,
  buttonSize = 64,
}) => {
  const previewNode = useRef<HTMLButtonElement>(null);
  const [poster, setPoster] = useState<string | undefined>(undefined);

  const buttonStyle = buttonSize && {
    height: `${buttonSize}px`,
    width: `${buttonSize}px`,
    fontSize: `${(buttonSize / 3) * 2}px`,
    left: `calc(50% - ${buttonSize}px / 2)`,
    top: `calc(50% - ${buttonSize}px / 2)`,
  };

  useEffect(() => {
    const newPoster =
      posterImage ??
      getPoster(
        thumbnails?.[0]?.sources,
        previewNode?.current?.clientWidth ?? 0
      );

    setPoster(newPoster);
  }, [previewNode, posterImage, thumbnails]);

  return (
    <Styled.PreviewModeWrapper
      type="button"
      style={{ backgroundImage: 'url(' + poster + ')' }}
      onClick={onClick}
      ref={previewNode}
    >
      <Styled.PlayButton style={{ ...buttonStyle }} />
    </Styled.PreviewModeWrapper>
  );
};
